export const GET_STARTED_DATA = 'GET_STARTED_DATA';
export const GET_STARTED_DRAFT_SELECTED_SPEAKER_IDS =
    'GET_STARTED_DRAFT_SELECTED_SPEAKER_IDS';
export const GET_STARTED_DRAFT_SELECTED_PAIRS = 'GET_STARTED_DRAFT_SELECTED_PAIRS_V1';
export const GET_STARTED_NEW_USER_RESPONSE = 'GET_STARTED_NEW_USER_RESPONSE';

export const PLAYBACK_RATE = 'PLAYBACK_RATE';
export const APP_THEME = 'APP_THEME';
export const PLAYBACK_SKIP_BACKWARD_SECONDS_V1 = 'PLAYBACK_SKIP_BACKWARD_SECONDS_V1';
export const PLAYBACK_SKIP_FORWARD_SECONDS_V1 = 'PLAYBACK_SKIP_FORWARD_SECONDS_V1';
export const PENDING_CHAT_SHARE = 'PENDING_CHAT_SHARE_V1';
export const RECENT_SEARCHES = 'RECENT_SEARCHES_V1';

export const LIBRARY_ACTION_ORDER_V1 = 'LIBRARY_ACTION_ORDER_V1';
export const LIBRARY_ACTION_COLLAPSED_COUNT_V1 = 'LIBRARY_ACTION_COLLAPSED_COUNT_V1';

export const PLAYBACK_SKIP_INTERVAL_OPTIONS = [5, 10, 15, 30, 45, 60];
export const DEFAULT_PLAYBACK_SKIP_BACKWARD_SECONDS = 15;
export const DEFAULT_PLAYBACK_SKIP_FORWARD_SECONDS = 30;

export const TIP_IMPORT_PODCASTS = 'TIP_IMPORT_PODCASTS';
export const TIP_PREVIEW_PAGER_SWIPE_LEARNED_V1 = 'TIP_PREVIEW_PAGER_SWIPE_LEARNED_V1';
export const TIP_SAVED_LIST_PICKER_LEARNED_V1 = 'TIP_SAVED_LIST_PICKER_LEARNED_V1';
export const TIP_LIBRARY_FOLLOWING_LEARNED_ACCOUNTS_V1 = 'TIP_LIBRARY_FOLLOWING_LEARNED_ACCOUNTS_V1';


export const clearAllTipsOnLogout = () => {
    const previewPagerSwipeLearned = localStorage.getItem(TIP_PREVIEW_PAGER_SWIPE_LEARNED_V1);
    const savedListPickerLearned = localStorage.getItem(TIP_SAVED_LIST_PICKER_LEARNED_V1);
    const libraryFollowingLearned = localStorage.getItem(TIP_LIBRARY_FOLLOWING_LEARNED_ACCOUNTS_V1);
    const importPodcastsDismissed = localStorage.getItem(TIP_IMPORT_PODCASTS);
    const libraryActionOrder = localStorage.getItem(LIBRARY_ACTION_ORDER_V1);
    const libraryCollapsedActionCount = localStorage.getItem(LIBRARY_ACTION_COLLAPSED_COUNT_V1);
    const playbackSkipBackwardSeconds = localStorage.getItem(PLAYBACK_SKIP_BACKWARD_SECONDS_V1);
    const playbackSkipForwardSeconds = localStorage.getItem(PLAYBACK_SKIP_FORWARD_SECONDS_V1);
    const appTheme = localStorage.getItem(APP_THEME);
    localStorage.clear();
    if (previewPagerSwipeLearned !== null) {
        localStorage.setItem(TIP_PREVIEW_PAGER_SWIPE_LEARNED_V1, previewPagerSwipeLearned);
    }
    if (savedListPickerLearned !== null) {
        localStorage.setItem(TIP_SAVED_LIST_PICKER_LEARNED_V1, savedListPickerLearned);
    }
    if (libraryFollowingLearned !== null) {
        localStorage.setItem(TIP_LIBRARY_FOLLOWING_LEARNED_ACCOUNTS_V1, libraryFollowingLearned);
    }
    if (importPodcastsDismissed !== null) {
        localStorage.setItem(TIP_IMPORT_PODCASTS, importPodcastsDismissed);
    }
    if (libraryActionOrder !== null) {
        localStorage.setItem(LIBRARY_ACTION_ORDER_V1, libraryActionOrder);
    }
    if (libraryCollapsedActionCount !== null) {
        localStorage.setItem(LIBRARY_ACTION_COLLAPSED_COUNT_V1, libraryCollapsedActionCount);
    }
    if (playbackSkipBackwardSeconds !== null) {
        localStorage.setItem(PLAYBACK_SKIP_BACKWARD_SECONDS_V1, playbackSkipBackwardSeconds);
    }
    if (playbackSkipForwardSeconds !== null) {
        localStorage.setItem(PLAYBACK_SKIP_FORWARD_SECONDS_V1, playbackSkipForwardSeconds);
    }
    if (appTheme !== null) {
        localStorage.setItem(APP_THEME, appTheme);
    }
}
